import { Button } from "@/components/ui/button";
import { Search, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "motion/react";

export function Hero() {
  return (
    <div className="relative overflow-hidden bg-slate-950 py-24 sm:py-32">
      <div className="absolute inset-0 z-0">
        <motion.img
          src="https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2070&auto=format&fit=crop"
          alt="Futuristic Digital Marketplace"
          className="h-full w-[120%] max-w-none object-cover opacity-50"
          referrerPolicy="no-referrer"
          animate={{
            x: ["-10%", "0%", "-10%"],
            scale: [1.05, 1.1, 1.05],
          }}
          transition={{
            duration: 40,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/60 to-slate-950" />
        <div className="absolute inset-0 bg-slate-950/40" />
      </div>
      
      <div className="container relative z-10 px-4 md:px-8">
        <div className="max-w-2xl bg-slate-950/20 backdrop-blur-[2px] p-6 rounded-3xl border border-white/5">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl drop-shadow-md">
            El centro comercial digital de los <span className="metallic-water-text">emprendedores</span>
          </h1>
          <p className="mt-6 text-lg leading-8 text-slate-200 drop-shadow-sm">
            Descubre productos únicos, servicios excepcionales y apoya el talento local. 
            Todo en un solo lugar, directo del creador a tu puerta.
          </p>
          
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                placeholder="¿Qué estás buscando hoy?"
                className="h-12 w-full rounded-lg bg-slate-900/60 border border-white/10 px-10 text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary backdrop-blur-md transition-all"
              />
            </div>
            <Link to="/shops">
              <Button size="lg" className="h-12 px-8 w-full sm:w-auto">
                Explorar Ahora
              </Button>
            </Link>
          </div>
          
          <div className="mt-8 flex items-center gap-x-6">
            <Link to="/become-seller" className="text-sm font-semibold leading-6 text-white flex items-center group">
              ¿Eres emprendedor? Crea tu tienda <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
